import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    standalone: false,
  selector: 'prompt-component',
  templateUrl: 'prompt.component.html'
})

export class PromptComponent {
  isChecked: boolean = false;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public formBuilder: FormBuilder,
    public authenticationService: AuthenticationService) {
    this.form = formBuilder.group({
      value: ['', Validators.required]
    })
  }


  onClose(withData: boolean): void {
    if (!withData || this.form.valid) {
      this.dialogRef.close(withData ? this.form.value.value : null);
    }
  }
}
